import React, { useContext, useState } from 'react'
import { useFirebaseApp, useFirestoreCollection } from 'reactfire'
import { Box, Header, Heading, Main, Paragraph, Select } from 'grommet'

import { AuthContext } from '../Firebase/Auth'
import GetScores from './GetScores'

function CompareProperty() {
  const { currentUser } = useContext(AuthContext)
  //const [collections, setCollections] = useState({})
  const collections = {}
  const [property, setProperty] = useState('')

  const firebaseApp = useFirebaseApp()
  const collectionsRef = firebaseApp.firestore().collection(currentUser.uid)
  const collectionsDoc = useFirestoreCollection(collectionsRef)
  const collectionsArr = collectionsDoc.docs

  for (const collection of collectionsArr) {
    if (collection.id !== 'preferences' && !collections[collection.id]) {
      const addressObject = collection._document.proto.fields.address
      const address = Object.values(addressObject)[0]

      if (!collections[collection.id]) {
        collections[collection.id] = address
      }
    }
  }

  const handleChange = (option) => {
    setProperty(option)
  }

  return (
    <Main>
      <Header background="brand" pad="medium">
        <Heading style={{ fontSize: '3rem', textAlign: 'center', width: '100%' }}>
          Compare Property
        </Heading>
      </Header>
      <Box pad="medium">
        <Paragraph>Check the scores that this place has received by all users.</Paragraph>
        <br />
        <Select
          options={Object.values(collections)}
          value={property}
          onChange={({ option }) => handleChange(option)}
          placeholder="Select Property"
        />
        <br />
        <GetScores
          property={
            Object.keys(collections).find((id) => collections[id] === property) || ''
          }
        />
      </Box>
    </Main>
  )
}

export default CompareProperty
